import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Tag } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"

export default function TagForm({ item, save, ref }: FormInDialogProps<Tag>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        nome_it: "",
        nome_en: "",
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome_it: yup.string().required().label(t("tag.nome_it")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Tag).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="nome_it"
                  label={t("tag.nome_it")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="nome_en"
                  label={t("tag.nome_en")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
